import React, {Component} from 'react'
import {Spin} from 'antd'
import PartnerRow from './table/PartnerRow'
import PropTypes from "prop-types"
import BulkSelectAll from './table/BulkSelectAll'
import BulkActions from './table/BulkActions'

class PartnersTable extends Component {
    state = {
        loadingAction: false,
        listSelected: [],
        selectedAll: false
    }

    // Theo dõi props.filter thay đổi để reset selectedAll
    componentDidUpdate(prevProps) {
        const prev = prevProps.filters;
        const next = this.props.filters;

        if (
            prev.name !== next.name ||
            prev.type !== next.type ||
            prev.hidden !== next.hidden
        ) {
            // filters thay đổi, reset selectedAll
            this.setState({ 
                selectedAll: false,
                listSelected: [],
            });
        }
    }

    _toggleSelectAll = (isChecked) => {
        const {partners} = this.props
        if (isChecked) {
            const itemIds = partners.map(item => item._id)
            this.setState({
                listSelected: itemIds,
                selectedAll: true
            })
        } else {
            this.setState({
                listSelected: [],
                selectedAll: false
            })
        }
    }

    _handleSendLoading = (value) => {
        this.setState({
            loadingAction: value
        })
    }

    _updateSelectedOrders = (id, value) => {
        const {listSelected} = this.state
        const {partners} = this.props
        if (value && !listSelected.includes(id)) {
            this.setState({
                listSelected: [...listSelected, id],
                selectedAll: listSelected.length + 1 === partners.length
            })
        } else {
            const filtered = listSelected.filter(itemId => itemId !== id)
            this.setState({
                listSelected: filtered,
                selectedAll: false
            })
        }
    }

    render() {
        const {loadingAction, selectedAll, listSelected} = this.state
        const cols = ['Tên đối tác', 'Nhóm sản xuất', 'Loại đối tác', 'Người nhận hàng', 'SĐT', 'Ngày tạo', 'Số lô ', 'Hành động']
        const {loading, partners, reset, filters} = this.props

        return (
            <div className="PartnersTable">
                <Spin spinning={loading} tip='Đang tải...'>
                    <table className='table table-borderless table-striped'>
                        <thead className='thead-light'>
                            {loadingAction ? (
                                <tr>
                                    <BulkSelectAll selectedAll={selectedAll} listSelected={listSelected} loadingAction={loadingAction} toggleSelectAll={this._toggleSelectAll}/>
                                    <th colSpan={13} className="position-relative">
                                        Sending...
                                    </th>
                                </tr>
                            ) : listSelected.length > 0 ? (
                                <tr>
                                    <BulkSelectAll selectedAll={selectedAll} listSelected={listSelected} loadingSend={loadingAction} toggleSelectAll={this._toggleSelectAll}/>
                                    <th colSpan={13} className="position-relative">
                                        <BulkActions refreshPartner={reset} partners={partners} listSelected={listSelected} toggleSelectAll={this._toggleSelectAll} handleSendLoading={this._handleSendLoading} filters={filters}/>
                                    </th>
                                </tr>
                            ) : (
                                <tr>
                                    <BulkSelectAll selectedAll={selectedAll} listSelected={listSelected} loadingSend={loadingAction} toggleSelectAll={this._toggleSelectAll}/>
                                    {
                                        cols.map((item, index) => {
                                            return <th key={index}>{item}</th>
                                        })
                                    }
                                </tr>
                            )}
                        </thead>
                        <tbody>
                        {
                            partners.length > 0 ? (
                                <PartnerRow {...this.props} loadingAction={loadingAction}
                                                handleSendLoading={this._handleSendLoading}
                                                listSelected={listSelected}
                                                updateSelectedOrders={this._updateSelectedOrders}
                                                />
                            ) : (
                                <tr>
                                            <td colSpan={cols.length + 1}>Không có dữ liệu</td>
                                </tr>
                            )
                        }
                        </tbody>
                    </table>
                </Spin>
            </div>
        )
    }
}

PartnersTable.propTypes = {
    loading: PropTypes.bool.isRequired,
    partnerURL: PropTypes.string,
    partners: PropTypes.array.isRequired
}

export default PartnersTable